import { apiGet, apiPost, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Vendor Categories Service
 * Handles vendor category and subcategory management
 */
const ProductCategoriesService = {
  /**
   * Get all product categories without pagination
   * @param {Object} options - Options for fetching categories
   * @param {number} options.page - Page number (default: 1)
   * @param {number} options.pageSize - Items per page (default: 1000)
   * @param {string} options.searchtext - Search text (optional)
   * @param {boolean} options.is_active - Filter by active status (default: true)
   * @param {boolean} options.is_custom - Filter by custom status (optional)
   * @returns {Promise} API response
   */
  async getAllProductCategories({ page = 1, pageSize = 1000, searchtext = "", is_active = true, is_custom } = {}) {
    // Try to get all data by setting a very large page size
    const params = {
      page,
      pageSize,
      is_active,
      ...(searchtext && { searchtext }),
      ...(is_custom !== undefined && { is_custom })
    };
    return apiGet(API_ENDPOINTS.PRODUCT_CATEGORIES.GET_ALL, params);
  },

  /**
   * Create new product category
   * @param {Object} categoryData - Category creation data
   * @returns {Promise} API response
   */
  async createCategory(categoryData) {
    return apiPost(API_ENDPOINTS.PRODUCT_CATEGORIES.CREATE, categoryData);
  },

  /**
   * Create new subcategory
   * @param {Object} subcategoryData - Subcategory creation data
   * @returns {Promise} API response
   */
  async createSubCategory(subcategoryData) {
    return apiPost(API_ENDPOINTS.PRODUCT_CATEGORIES.CREATE_SUB, subcategoryData);
  },

  /**
   * Update category order
   * @param {Array} categoryIds - Array of category IDs in new order
   * @param {boolean} isSubcategory - Whether updating subcategory order
   * @returns {Promise} API response
   */
  async updateCategoryOrder(categoryIds, isSubcategory = false) {
    return apiPost(API_ENDPOINTS.PRODUCT_CATEGORIES.UPDATE_ORDER, {
      category_ids: categoryIds,
      is_subcategory: isSubcategory
    });
  },

  /**
   * Update product category (parent category)
   * Matches admin API: POST /api/v1/admin/product-category
   * @param {Object} payload
   * @param {string} payload.category_id
   * @param {string} payload.category_name
   * @param {string} payload.category_image
   * @param {string} payload.description
   * @param {boolean} payload.is_active
   */
  async updateCategory(payload) {
    return apiPost(API_ENDPOINTS.PRODUCT_CATEGORIES.UPDATE, payload);
  },

  /**
   * Update subcategory
   * Matches admin API: POST /api/v1/admin/subcategory
   * @param {Object} payload
   * @param {string} payload.subcategory_id
   * @param {string} payload.category_name
   * @param {string} payload.description
   * @param {boolean} payload.is_active
   * @param {string} payload.parent_category_id (optional)
   */
  async updateSubCategory(payload) {
    return apiPost(API_ENDPOINTS.PRODUCT_CATEGORIES.UPDATE_SUB, payload);
  },

  
};

export default ProductCategoriesService; 